import moment from "moment";
import { getFullName } from "../../util/helpers";
import { getLocalPhoneNumber, getPdfMargins } from "../../util/helpers";

export const getItems = (data, record) => {
  let final = [];
  if (
    record.client &&
    record.client.category &&
    record.client.category.social_security
  ) {
    final = getSocialSecurityItems(data, record);
  } else if (
    record.client &&
    record.client.category &&
    record.client.category.holocast_fund
  ) {
    final = getHolocastFundItems(data, record);
  } else if (
    record.client &&
    record.client.category &&
    record.client.category.ministry_of_defence
  ) {
    final = getMinistryOfDefenceItems(data, record);
  } else if (record.client) {
    final = getSocialSecurityItems(data, record);
  }

  return final;
};

export const getColumns = (record) => {
  let final = {};

  if (
    record.client &&
    record.client.category &&
    record.client.category.social_security
  ) {
    final = getSocialSecurityColumns();
  } else if (
    record.client &&
    record.client.category &&
    record.client.category.holocast_fund
  ) {
    final = getHolocastFundColumns();
  } else if (
    record.client &&
    record.client.category &&
    record.client.category.ministry_of_defence
  ) {
    final = getMinistryOfDefenceColumns();
  } else if (record.client) {
    final = getSocialSecurityColumns();
  }
  return final;
};

export const getSocialSecurityItems = (data, record) => {
  let final = [];
  const date = moment().set("year", record.year);
  date.set("month", record.month - 1);
  data.forEach((item, i) => {
    let temp = {
      employee_type_id: item?.employee?.employee_type_id,
      // employee_local_id_number: item["employee"].local_id_number,
      supervision_day: item.house_visit_date
        ? moment(item.house_visit_date).format("DD")
        : "99",
      supervision_code:
        item["house_visit_code"] === 0 ? "" : item["house_visit_code"],
      missing_hours_reason: item["missing_hours_reason"],
      charged_amount: item["charged_amount"].toFixed(2),
      tariff: item["tariff"].toFixed(2),
      charged_units: item["charged_units"],
      employee_local_id_number: item?.employee?.local_id_number,
      employee_name: item?.employee
        ? getFullName(item?.employee?.surename, item?.employee?.first_name)
        : record.supporting_community
        ? "קהילה תומכת"
        : record.day_center
        ? "מרכז יום"
        : "",
      period: `${moment(date).startOf("month").format("DD/MM/YY")}-${moment(
        date
      )
        .endOf("month")
        .format("DD/MM/YY")}`,
      service_type: record.supporting_community
        ? "008"
        : record.day_center
        ? "002"
        : item["order"]["client"]["social_security"]
        ? "001"
        : "003",
      max_hours: record.day_center ? "1" : item["order"].max_hours, //temporary show 1 for day center
      patient_local_id_number: item["order"].patient.local_id_number,
      patient_first_name: item["order"].patient.first_name,
      patient_surename: item["order"].patient.surename,
      line_number: item["line_number"],
    };
    final.push(temp);
  });
  return final;
};

export const getSocialSecurityColumns = () => {
  const columnStyles = {
    0: { cellWidth: 10 },
    1: { cellWidth: 12 },
    2: { cellWidth: 12 },
    3: { cellWidth: 11 },
    4: { cellWidth: 18.3 },
    5: { cellWidth: 13 },
    6: { cellWidth: 14.5 },
    7: { cellWidth: 22 },
    8: { cellWidth: 23 },
    9: { cellWidth: 34 },
    10: { cellWidth: 14 },
    11: { cellWidth: 13 },
    12: { cellWidth: 22 },
    13: { cellWidth: 18.4 },
    14: { cellWidth: 20.4 },
    15: { cellWidth: 11 },
  };
  return columnStyles;
};

export const getHolocastFundItems = (data, record) => {
  let final = [];
  const date = moment().set("year", record.year);
  date.set("month", record.month - 1);
  data.forEach((item, i) => {
    let temp = {
      employee_type_id: item["employee"].employee_type_id,
      // employee_local_id_number: item["employee"].local_id_number,
      supervision_day: item.house_visit_date
        ? moment(item.house_visit_date).format("DD")
        : "99",
      supervision_code:
        item["house_visit_code"] === 0 ? "" : item["house_visit_code"],
      missing_hours_reason: item["missing_hours_reason"],
      charged_amount: item["charged_amount"].toFixed(2),
      tariff: item["tariff"].toFixed(2),
      charged_units: item["charged_units"],
      employee_local_id_number: item["employee"].local_id_number,
      employee_name: getFullName(
        item["employee"].surename,
        item["employee"].first_name
      ),
      period: `${moment(date).startOf("month").format("DD/MM/YY")}-${moment(
        date
      )
        .endOf("month")
        .format("DD/MM/YY")}`,
      service_type: item["order"]["client"]["social_security"] ? "001" : "003",
      max_hours: item["order"].max_hours,
      commitment_number: item["order"].commitment_number,
      patient_local_id_number: item["order"].patient.local_id_number,
      patient_first_name: item["order"].patient.first_name,
      patient_surename: item["order"].patient.surename,
      line_number: item["line_number"],
    };
    final.push(temp);
  });
  return final;
};

export const getHolocastFundColumns = () => {
  const columnStyles = {
    0: { cellWidth: 10 },
    1: { cellWidth: 11 },
    2: { cellWidth: 11 },
    3: { cellWidth: 11 },
    4: { cellWidth: 16 },
    5: { cellWidth: 12 },
    6: { cellWidth: 12 },
    7: { cellWidth: 20 },
    8: { cellWidth: 23 },
    9: { cellWidth: 34 },
    10: { cellWidth: 11 },
    11: { cellWidth: 12 },
    12: { cellWidth: 23 },
    13: { cellWidth: 21 },
    14: { cellWidth: 15 },
    15: { cellWidth: 17 },
    16: { cellWidth: 10 },
  };
  return columnStyles;
};

export const getMinistryOfDefenceItems = (data, record) => {
  let final = [];
  const date = moment().set("year", record.year);
  date.set("month", record.month - 1);
  data.forEach((item, i) => {
    let temp = {
      charged_amount: item["charged_amount"].toFixed(2),
      tariff: item["tariff"].toFixed(2),
      charged_units: item["charged_units"],
      employee_local_id_number: item["employee"].local_id_number,
      employee_name: getFullName(
        item["employee"].surename,
        item["employee"].first_name
      ),
      period: `${moment(date).startOf("month").format("DD/MM/YY")}-${moment(
        date
      )
        .endOf("month")
        .format("DD/MM/YY")}`,
      service_type: item["order"]["client"]["social_security"] ? "001" : "003",
      max_hours: item["order"].max_hours,
      reference_number: item["order"].reference_number,
      commitment_number: item["order"].commitment_number,
      patient_local_id_number: item["order"].patient.local_id_number,
      patient_first_name: item["order"].patient.first_name,
      patient_surename: item["order"].patient.surename,
      line_number: item["line_number"],
    };
    final.push(temp);
  });
  return final;
};

export const getMinistryOfDefenceColumns = () => {
  const columnStyles = {
    0: { cellWidth: 17 },
    1: { cellWidth: 14 },
    2: { cellWidth: 14 },
    3: { cellWidth: 23 },
    4: { cellWidth: 25.4 },
    5: { cellWidth: 34 },
    6: { cellWidth: 13 },
    7: { cellWidth: 14 },
    8: { cellWidth: 24.5 },
    9: { cellWidth: 24.5 },
    10: { cellWidth: 23 },
    11: { cellWidth: 15 },
    12: { cellWidth: 17 },
    13: { cellWidth: 10 },
  };
  return columnStyles;
};

export const setHeader = (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var title = record.is_self_participating
    ? `מס״ב השתתפות עצמית - ${record.clientCategoryName}`
    : record.isSocialSecurity
    ? "ענף ביטוח סיעוד - המוסד לביטוח לאומי"
    : record.clientCategoryName;
  const taxNumberTitle = "מספר ח.פ./עוסק מורשה";
  const taxNumber = record.taxId;
  const serviceProviderTitle = "מספר נותן שירות";
  const serviceProviderNumber = record.supporting_community
    ? record.supporting_community_service_provider_number
    : record.serviceProviderNumber;
  const careGiverTitle = "שם נותן השירותים";
  const serialNumberTitle = "מספר חשבון";
  const branchNumberTitle = "מספר סניף";
  const comitteeNumberTitle = "מספר ועדה";
  const clientNumberTitle = "מספר מזמין";
  const careGiver = record.organizationName;
  const clientName = record.clientName;
  const serialNumber = record.serial_number;
  const to = "לכבוד";
  const comitteeName = clientName;
  const reportTitleStart = record.is_self_participating
    ? "דיווח על חיוב מסב"
    : "דיווח על";
  const reportTitle = record.supporting_community
    ? `${reportTitleStart} קהילה תומכת`
    : record.day_center
    ? `${reportTitleStart} מרכז יום`
    : `${reportTitleStart} מתן שירותי סיעוד בבית`;
  const report = "חודש דיווח";
  const date = `${record.month}/${record.year}`;
  const firstLine = record.isSelfPayments
    ? record.paymentsName
    : record.isSocialSecurity
    ? `${to} ${comitteeName}`
    : `${to} ${clientName}`;
  const secondLine = record.isSelfPayments
    ? record.paymentsAddress
    : record.isSocialSecurity
    ? `${branchNumberTitle}: ${record.organizationBranchNumber}, ${comitteeNumberTitle}: ${record.comitteeNumber}`
    : record.accountingCode
    ? `${clientNumberTitle}: ${record.accountingCode}`
    : "";
  const comapnyName = `${careGiverTitle}: ${careGiver}`;
  const companyTaxNumber = `${taxNumberTitle}: ${taxNumber}`;
  const serviceProvider = serviceProviderNumber
    ? `${serviceProviderTitle}: ${serviceProviderNumber}`
    : "";
  const reportDate = `${report}: ${date}`;
  const serialLine =
    serialNumber === 0 ? `תשקיף דמה` : `${serialNumberTitle}: ${serialNumber}`;
  const branchName = `${record.organizationName} - ${record.branch.name}`;
  const branchNumber = `מספר סניף: ${
    record.supporting_community
      ? "קהילה תומכת - "
      : record.day_center
      ? "מרכז יום - "
      : ""
  }${
    record.supporting_community
      ? record.branch.supporting_community_accounting_number
      : record.day_center
      ? record.branch.day_center_accounting_number
      : record.client.btl_accounting_number ||
        record.branch.btl_accounting_number
  }`;
  const branchPhone = `טלפון: ${getLocalPhoneNumber(
    record.branch.phone_number
  )}`;
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.text(title, hLoc, 20, {
    align: "right",
  });

  doc.setFontSize(11);
  doc.text(firstLine, hLoc, 25, {
    align: "right",
  });

  doc.text(secondLine, hLoc, 30, {
    align: "right",
  });

  doc.text(reportTitle, hLoc, 35, {
    align: "right",
  });

  doc.text(branchName, hLoc - 145, 20, {
    align: "center",
  });
  doc.setFontSize(10);

  doc.text(branchNumber, hLoc - 145, 26, {
    align: "center",
  });
  doc.text(branchPhone, hLoc - 145, 31, {
    align: "center",
  });

  doc.text(comapnyName, margins, 20, {
    align: "left",
  });
  doc.text(companyTaxNumber, margins, 24, {
    align: "left",
  });
  doc.text(serviceProvider, margins, 28, {
    align: "left",
  });

  doc.text(reportDate, margins, 32, {
    align: "left",
  });
  if (serialNumber === 0) {
    doc.setTextColor("red");
  }
  doc.text(serialLine, margins, 36, {
    align: "left",
  });
  doc.setTextColor(40);
};

export const setBottomContent = (
  doc,
  lines,
  record,
  setHeader,
  headerRecord
) => {
  let finalY = doc.lastAutoTable.finalY;
  if (doc.internal.pageSize.height - finalY < 73) {
    doc.addPage();
    setHeader(doc, headerRecord);
    finalY = 40;
  }
  var hLoc = doc.internal.pageSize.getWidth() - 15;
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const authorizeName = "שם";
  const role = "תפקיד";
  const signature = "חתימה";
  const date = "תאריך";
  const serviceAuthorize = "אישור נותן השירות:";
  const comitteAutorize = "אישור מרכז הוועדה:";
  const accountantAutorize = "אישור פקיד החשבונות:";
  const prospectusAutorize = `אישור לח״ן מספר: ${record.serial_number}`;

  const supervisionTitle = "מקרא קוד מפקח:";
  const supervisionDetails = "עו״ס-1 אחות-2 בקר-3 גרנטולוג-4";
  const serviceTypeTitle = "מקרא סוג עובד/ת:";
  const serviceTypeDetails = "אזרח-1 זר-2 שטחים-3";

  const printedAt = `תאריך הפקה:   ${moment(record.createdAt).format(
    "DD/MM/YY"
  )}`;
  const createdAt = `תאריך הדפסה: ${moment().format("DD/MM/YY")}`;
  if (finalY) {
    let totalSum = new Intl.NumberFormat("he", {
      style: "currency",
      currency: "ILS",
    }).format(record.chargedAmount);
    if (totalSum.includes("-")) {
      const num = record["chargedAmount"].toString() + ".00";
      totalSum = num.split("").reverse().join("") + " ₪";
    }
    const total = "סה״כ לתשלום";
    const totalHours = `${record.chargedUnits}`;
    const hours = "סה״כ יחידות";

    //summary
    doc.setFontSize(12);
    doc.text(hours, hLoc - 86, finalY + 5, {
      align: "right",
    });
    doc.text(totalHours.split("").reverse().join(""), hLoc - 110, finalY + 5, {
      align: "right",
    });
    doc.text(total, hLoc - 152, finalY + 5, {
      align: "right",
    });
    doc.text(totalSum, hLoc - 177.8, finalY + 5, {
      align: "right",
    });
    doc.setFontSize(10);

    //authorization section
    doc.text(prospectusAutorize, hLoc, finalY + 20, {
      align: "right",
    });
    doc.text(serviceAuthorize, hLoc - 45, finalY + 20, {
      align: "right",
    });
    doc.text(comitteAutorize, hLoc - 45, finalY + 27, {
      align: "right",
    });
    doc.text(accountantAutorize, hLoc - 45, finalY + 34, {
      align: "right",
    });

    //signature details
    doc.text(authorizeName, hLoc - 96, finalY + 40, {
      align: "right",
    });

    doc.text(role, hLoc - 127, finalY + 40, {
      align: "right",
    });

    doc.text(signature, hLoc - 159, finalY + 40, {
      align: "right",
    });

    doc.text(date, hLoc - 192, finalY + 40, {
      align: "right",
    });

    //fields details
    doc.text(supervisionTitle, hLoc - 219, finalY + 20, {
      align: "right",
    });
    doc.text(supervisionDetails, hLoc - 219, finalY + 25, {
      align: "right",
    });
    doc.text(serviceTypeTitle, hLoc - 219, finalY + 33, {
      align: "right",
    });
    doc.text(serviceTypeDetails, hLoc - 219, finalY + 38, {
      align: "right",
    });

    doc.text(printedAt, hLoc - 219, finalY + 53, {
      align: "right",
    });
    doc.text(createdAt, hLoc - 219, finalY + 58, {
      align: "right",
    });

    doc.setDrawColor(40);
    doc.setLineWidth(0.5);
    if (record.isSocialSecurity) {
      doc.line(hLoc - 86, finalY + 20, hLoc - 112, finalY + 20);
      doc.line(hLoc - 120, finalY + 20, hLoc - 144, finalY + 20);
      doc.line(hLoc - 152, finalY + 20, hLoc - 177, finalY + 20);
      doc.line(hLoc - 184, finalY + 20, hLoc - 209, finalY + 20);

      doc.line(hLoc - 86, finalY + 27, hLoc - 112, finalY + 27);
      doc.line(hLoc - 120, finalY + 27, hLoc - 144, finalY + 27);
      doc.line(hLoc - 152, finalY + 27, hLoc - 177, finalY + 27);
      doc.line(hLoc - 184, finalY + 27, hLoc - 209, finalY + 27);

      doc.line(hLoc - 86, finalY + 34, hLoc - 112, finalY + 34);
      doc.line(hLoc - 120, finalY + 34, hLoc - 144, finalY + 34);
      doc.line(hLoc - 152, finalY + 34, hLoc - 177, finalY + 34);
      doc.line(hLoc - 184, finalY + 34, hLoc - 209, finalY + 34);
    } else {
      doc.line(hLoc - 86, finalY + 20, hLoc - 112, finalY + 20);
      doc.line(hLoc - 120, finalY + 20, hLoc - 144, finalY + 20);
      doc.line(hLoc - 152, finalY + 20, hLoc - 177, finalY + 20);
      doc.line(hLoc - 184, finalY + 20, hLoc - 209, finalY + 20);

      doc.line(hLoc - 86, finalY + 27, hLoc - 112, finalY + 27);
      doc.line(hLoc - 120, finalY + 27, hLoc - 144, finalY + 27);
      doc.line(hLoc - 152, finalY + 27, hLoc - 177, finalY + 27);
      doc.line(hLoc - 184, finalY + 27, hLoc - 209, finalY + 27);

      doc.line(hLoc - 86, finalY + 34, hLoc - 112, finalY + 34);
      doc.line(hLoc - 120, finalY + 34, hLoc - 144, finalY + 34);
      doc.line(hLoc - 152, finalY + 34, hLoc - 177, finalY + 34);
      doc.line(hLoc - 184, finalY + 34, hLoc - 209, finalY + 34);
    }
  }
};
